module.exports = __webpack_public_path__ + "img/ex02.094ae0b4.png";